export default {
  background: require('./headerBackground.jpg'),
  planeIcon: require('./plane.svg'),
  rec: require('./rec.svg'),
  world: require('./globe.svg'),
  backgroundMobile: require('./mobile-background.jpg'),
  mobileBackground: require('./mobile-background.jpg'),
};
